import { MediaBreakpoints } from './media-breakpoints.interface';

export const MEDIA_BREAKPOINTS: MediaBreakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600,
} as const;
